import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isLogin } from 'api';
import { wiseSsoCreator } from 'store/actionsCreators';

const WISE_SSO_STATE_KEY = 'wiseSsoState';

const WiseSso = ({ redirectToWise, history, location }) => {
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const urlState = queryParams.get('state');

    if (isLogin()) {
      const pendingState = window.localStorage.getItem(WISE_SSO_STATE_KEY);
      if (pendingState !== null) {
        window.localStorage.removeItem(WISE_SSO_STATE_KEY);
      }
      const effectiveState = urlState || pendingState || undefined;
      redirectToWise(history, effectiveState);
      return;
    }

    if (urlState !== null) {
      window.localStorage.setItem(WISE_SSO_STATE_KEY, urlState);
    }
    history.replace('/auth/login');
  }, []);

  return <></>;
};

WiseSso.propTypes = {
  redirectToWise: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  redirectToWise: (history, state) => dispatch(wiseSsoCreator(history, state)),
});

export default connect(null, mapDispatchToProps)(WiseSso);
